import React, { useContext } from "react";
import AppContext from "../../../context/AppContext";
import { Badge, Button, Card, Col } from "react-bootstrap";
import Swal from "sweetalert2";

const SingleStudyGroupCard = ({ group,handleDeleteGroup }) => {
  const { selectedStudyGroupScreenName } = useContext(AppContext);
  return (
   <Col lg={4} md={6} key={group.id} className="mb-4">
                 <Card className="group-card">
                   <Card.Body>
                     <div className="d-flex justify-content-between align-items-start mb-3">
                       <div>
                         <h5 className="group-name">{group.groupName}</h5>
                         <Badge bg="info" className="subject-badge">
                           {group.subjectName}
                         </Badge>
                       </div>
                     </div>
   
                     <p className="group-description">{group.description?.slice(0, 70)}...<span onClick={() => {
                       Swal.fire({
                         "title": "DETAILS",
                         "text": group.description
                       })
                     }} style={{ cursor: "pointer" }} className="text-success"><b>REAM MORE</b></span></p>
   
                     <div className="group-meta mb-3">
                       <div className="meta-item">
                         <i className="bi bi-people-fill"></i>
                         <span>{group.maximumMembers} Members</span>
                       </div>
                       {/* <div className="meta-item">
                         <i className="bi bi-person-badge"></i>
                         <span>{group.chmentor?.name || "No Mentor Assigned"}</span>
                       </div> */}
                     </div>
   
                     <div className="d-flex justify-content-between align-items-center">
                       <Badge
                         bg={group.status === "active" ? "success" : "secondary"}
                       >
                         {group.status}
                       </Badge>
                       <div className="group-actions">
                         {/* <Button
                           variant="outline-primary"
                           size="sm"
                          //  onClick={() => handleViewGroup(group)}
                         >
                           <i className="bi bi-eye"></i>
                         </Button> */}
                         {/* <Button
                           variant="outline-warning"
                           size="sm"
                          onClick={() => handleArchiveGroup(group.id)}
                         >
                           <i className="bi bi-archive"></i>
                         </Button> */}
                         <Button
                           variant="outline-danger"
                           size="sm"
                           onClick={() => handleDeleteGroup(group.id)}
                         >
                           <i className="bi bi-trash"></i>
                         </Button>
                       </div>
                     </div>
                   </Card.Body>
                 </Card>
               </Col>
  );
};

export default SingleStudyGroupCard;
